import { z } from 'zod';

// Define the schema for the search form
export const searchSchema = z.object({
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
  voucherNumberStart: z.string().optional(),
  voucherNumberEnd: z.string().optional(),
  exportType: z.string().optional(),
  transactionType: z.string().optional(),
  customerCode: z.string().optional(),
  debitAccount: z.string().optional(),
  employeeCode: z.string().optional(),
  description: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
